var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { ESCAPE_KEY } from '../../../const/keyNames';
import TabTrap from '../../../helpers/TabTrap';
import { ModalWrapper, Overlay, StyledFooter } from './subcomponents';
import { useOutsideAlerter } from '../../atoms/Select/helpers';
const SimpleModal = (_a) => {
    var { id, children, header, className, footerButtons, footerClassName, isOpen, headerRef, escapeModalHandler, outsideClickHandler } = _a, props = __rest(_a, ["id", "children", "header", "className", "footerButtons", "footerClassName", "isOpen", "headerRef", "escapeModalHandler", "outsideClickHandler"]);
    const modalRef = useRef();
    const TRANSITION_DURATION = 250;
    const [postAnimationState, setPostAnimationState] = useState(false);
    const [modalStyles, setModalStyles] = useState({
        transform: '',
        opacity: 1
    });
    const handleKeyDown = (event) => {
        if (event && event.key === ESCAPE_KEY) {
            event.stopPropagation();
            escapeModalHandler();
        }
    };
    useOutsideAlerter(modalRef, outsideClickHandler);
    useEffect(() => {
        // set focus to the header when modal is opened
        if (isOpen && (headerRef === null || headerRef === void 0 ? void 0 : headerRef.current)) {
            headerRef.current.focus();
            // React Ref and styled-components weren't working for this case :(
            setModalStyles({
                transform: 'translate(-50%, -25%)',
                opacity: 1
            });
            setPostAnimationState(true);
        }
        if (!isOpen && (headerRef === null || headerRef === void 0 ? void 0 : headerRef.current)) {
            // React Ref wasn't working for this case
            setModalStyles({
                transform: 'translate(-50%, -60%)',
                opacity: 0
            });
            setTimeout(() => {
                setPostAnimationState(false);
            }, TRANSITION_DURATION);
        }
    }, [isOpen, headerRef, id]);
    return (_jsx(Overlay, Object.assign({ isOpen: postAnimationState }, { children: (isOpen || postAnimationState) && (_jsx(TabTrap, { children: _jsxs(ModalWrapper, Object.assign({}, props, { ref: modalRef, role: "dialog", id: id, "aria-hidden": !isOpen, className: className, transitionDuration: TRANSITION_DURATION, style: modalStyles, onKeyDown: handleKeyDown }, { children: [!!header && header, _jsx("div", Object.assign({ ref: !header ? headerRef : null }, { children: children })), footerButtons && (_jsx(StyledFooter, Object.assign({ className: footerClassName }, { children: footerButtons })))] })) })) })));
};
export default SimpleModal;
//# sourceMappingURL=SimpleModal.js.map